/**
 * Procedure Categories and Procedures for M.Ch. in Hand Surgery students
 * Extracted with strict evidence from official NMC PDF (Page 3-4: "Psychomotor domain - Perform the following")
 */
export const HAND_SURGERY_PROCEDURES = {
  "Acute Hand Trauma, Fixation & Debridement Procedures": [
    "Primary Care of Hand Injuries: Wound Washing, Debridement & Splinting",
    "Closed & Open Reduction with Internal Fixation (K-Wires, Plates, Screws, Nailing) for Hand & Carpal Bones",
    "Application of External Fixators & Skeletal Stabilization of Upper Extremity Fractures",
    "Fasciotomy for Compartment Syndrome of Hand, Forearm & Arm",
    "Debridement & Reconstruction of Crushed & Mangled Upper Extremities",
    "Amputations of Upper Extremity at Digital, Hand, Forearm & Arm Levels",
  ],
  "Microvascular, Nerve, Tendon & Reconstructive Hand Procedures": [
    "Microvascular Replantation & Reconstruction of Amputated Digits & Hand",
    "Vascular Repair, Grafting & Reconstruction of Upper Extremity Vessels",
    "Neurorrhaphy, Nerve Grafting & Neural Reconstruction",
    "Flexor & Extensor Tendon Repair & Tendon Transfer Procedures",
    "Soft Tissue Coverage with Split/Full Thickness Skin Grafts & Local/Myofascial Flaps",
    "Regional Anaesthesia (Brachial Plexus Block, Intravenous Regional Anaesthesia & Digital Blocks)",
  ],
  "Reconstructive Joint, Arthroplasty & Arthroscopic Hand Procedures": [
    "Arthrodesis of Small Joints of Hand, Wrist & Upper Extremity",
    "Excision Arthroplasty & Joint Replacement (Wrist, Elbow, Shoulder & Small Joints)",
    "Bony & Soft Tissue Deformity Correction (Correction of Rheumatoid & Congenital Hand Deformities)",
    "Diagnostic & Operative Arthroscopy of Shoulder, Elbow, Wrist & Small Joints",
    "Excision of Hand & Upper Extremity Tumours with Bone Grafting / Transport",
  ],
};

export const HAND_SURGERY_CATEGORIES = Object.keys(HAND_SURGERY_PROCEDURES);

export const isMChInHandSurgeryDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("hand surgery") || (d.includes("hand") && d.includes("surgery"));
};
